
export const authRoleAccess = {
    dashborad: ['SuperAdmin', 'RestaurantAdmin', 'admin', 'manager', 'cashier', 'waiter', 'kitchen_staff'],
    dataSetup: ['SuperAdmin'],
    settings: ['SuperAdmin', 'RestaurantAdmin', 'admin', 'manager'],
    reports: ['SuperAdmin', 'RestaurantAdmin', 'admin', 'manager', 'cashier'],
    pos: ['SuperAdmin', 'RestaurantAdmin', 'admin', 'manager', 'cashier', 'waiter', 'kitchen_staff'],
    kds: ['SuperAdmin', 'RestaurantAdmin', 'admin', 'manager', 'kitchen_staff'],
    guestHubAdmin: ['SuperAdmin', 'RestaurantAdmin', 'admin', 'manager', 'waiter'],
    restaurantMenu: ['SuperAdmin', 'RestaurantAdmin', 'admin', 'manager', 'cashier', 'waiter', 'kitchen_staff'],
    profile: ['SuperAdmin', 'RestaurantAdmin', 'admin', 'manager', 'cashier', 'waiter', 'kitchen_staff'],
}